<template>
    <main>
         <div>
            <div class="card text-center" style="padding: 10px 5% 10px;">
                <div class="card-body">                                
                    <p class="colLetra J-help-alert-title" :class="'card-title'">Gootwork una plataforma desarrollada pensando en ti.</p>
                    <div style="padding-top: 0px;">
                        <button type="button" class="btn btn-lg" @click="busines()" style="color: #11679a;text-decoration: underline;">NEGOCIOS</button>
                        <div class="J-help-alert-message">
                            Contacte a restaurantes, bodegas, lavanderias, negocios independientes, etc.
                        </div>
                        <div class="J-help-alert-message">
                            Si tiene un negocio puede registrarse de forma gratuita ingresando <a @click="businesCreate()" href="javascript:void(0)">aquí</a>
                        </div>
                    </div>
                    <div style="padding-top: 10px;">
                        <button type="button" class="btn btn-lg" @click="help()" style="color: #11679a;text-decoration: underline;">¡QUIERO AYUDAR!</button>
                        <div class="J-help-alert-message">
                            Veras los pedidos de algunas Familias cercanas a Ti
                        </div>
                    </div>
                    <div style="padding-top: 10px;">
                        <button type="button" class="btn btn-lg" @click="searchHelp()"  style="color: #11679a;text-decoration: underline;">BUSCO AYUDA</button>
                        <div class="J-help-alert-message">
                            Podrás realizar un pedido básico, para que alguien te ayude                            
                        </div>
                    </div>
                    <!-- <div style="padding-top: 10px;">
                        <button type="button" class="btn btn-lg" @click="symptomsHelp()"  style="color: #11679a;text-decoration: underline;">TENGO SÍNTOMAS</button>
                        <div class="J-help-alert-message">
                            Realizarás un test
                        </div>
                    </div> -->
                </div>
            </div>
         </div>
    </main>
</template>
<script>
    import { EventBus } from '@/helpers/eventbus/event-bus'

    export default {
        methods:{
            busines:function(){
                this.$emit('close')
                EventBus.$emit('alert','busines')
            },
            businesCreate:function(){
                this.$emit('close')
                EventBus.$emit('alert','busines-create')
            },
            help:function(){
                this.$emit('close')
                EventBus.$emit('alert','help')

            },
            symptomsHelp:function(){
                this.$emit('close')
                EventBus.$emit('alert','symptoms-help')
            },
            searchHelp:function(){
                this.$emit('close')
                EventBus.$emit('alert','search-help')
            }
        }

    }
</script>